import React from "react";
import useLoadingList from "./useLoadingList";
/**
 * Keep track of items as they're asynchronously performed
 * ```
 * const [listOfA, listOfB, addToA] = useAsyncTransform(functionToTransformAtoB);
 * //...
 * addToA([A], (...arguments for functionToTransformAtoB));
 * ```
 *
 * addToA function accepts an array of A items as its first argument, and then the args passed to the service function
 *
 * All items in listOfA are being transformed.  Once they are transformed, they are put into listOfB and removed
 * from listOfA.
 *
 * @param {function(...[P]): Promise<R>} serviceMethod - transformation function
 * @returns {[T[], R[], Function, T[], ()=>void]} - startList, endList, startListActions, errorList, reset
 */
export default function useAsyncTransform(serviceMethod) {
    const [endList, setEndList] = React.useState([]);
    const wrappedServiceMethod = React.useMemo(() => 
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    (...args) => 
    // @ts-expect-error - TS2345 - Argument of type 'any[]' is not assignable to parameter of type 'P'.
    serviceMethod(...args).then((result) => {
        if (Array.isArray(result)) {
            setEndList((list) => [...list, ...result]);
        }
        else {
            setEndList((list) => [...list, result]);
        }
        return result;
    }), [serviceMethod]);
    const reset = React.useMemo(() => () => setEndList([]), []);
    const [startList, startListActions, errorList] = useLoadingList(wrappedServiceMethod);
    // @ts-expect-error - TS2322 - Type 'unknown[]' is not assignable to type 'T[]'. | TS2322 - Type 'unknown[]' is not assignable to type 'T[]'.
    return [startList, endList, startListActions, errorList, reset];
}
